import type { RootState } from 'state';
import type { FlightProvidersState } from '../slice';

function getFlightProviders(state: RootState): FlightProvidersState['value'] {
  const { value } = state.dataService.productProviders.flightProviders;
  return value;
}

export default getFlightProviders;
